import { h } from 'preact';

import VideosEditor from 'components/editor/movies/videos/videos';

import s from 'components/editor/movies/videos/videosUniversal.sss';

export default class UniversalVideosEditor extends VideosEditor {
	s = s;
}
